var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49698 9.66264C9.53865 9.66264 10.5598 9.66264 11.1938 9.0281C11.8283 8.3941 11.8283 7.37299 11.8283 5.33132C11.8283 3.28964 11.8283 2.26853 11.1938 1.63454C10.5598 1 9.53865 1 7.49698 1H5.33132C3.28964 1 2.26853 1 1.63454 1.63454C1 2.26853 1 3.28964 1 5.33132C1 7.37299 1 8.3941 1.63454 9.0281C1.98808 9.38218 2.46182 9.53865 3.16566 9.60741",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78979 5.33088L6.00798 6.41371L8.03828 4.24805",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49547 9.66173C6.82628 9.66173 6.08887 9.93244 5.41589 10.2817C4.33415 10.8431 3.79327 11.1241 3.5269 10.9449C3.26052 10.7662 3.31087 10.2113 3.41212 9.10191L3.43486 8.84961",
    stroke: "#004643",
    strokeWidth: 1.08283,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.4c059e63f05c74863764e23181256e6a.svg";
export { ForwardRef as ReactComponent };